import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import password from './modules/password'
import componentState from "./modules/componentState";

const SESSIONSTORAGE_KEY = process.env.VUE_APP_SESSIONSTORAGE_KEY

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    // 初回アクセス時初期処理（リロード時、強制ブラウジング時を含む）
    initAction({getters, dispatch}) {
      // トークンリフレッシュタイマーの再起動
      if (getters['auth/isLoggedIn']() && !getters['auth/isSessionTimedOut']()) {
        dispatch('auth/setIdTokenRefreshTimer')
      }
    }
  },
  modules: {
    auth,
    password,
    componentState
  },
  strict: true,    // ミューテーションハンドラ経由以外での更新を禁止
  plugins: [createPersistedState({
    key: SESSIONSTORAGE_KEY,
    storage: window.sessionStorage,
    paths: [
      'auth.idToken',
      'auth.refreshToken',
      'auth.expiresIn',
      'auth.tokenExpiresAt',
      'auth.sessionTimeOutAt',
      'auth.displayName',
      'auth.userId',
      'auth.clientId',
      'auth.affiliationId',
      'auth.safieClientId',
      'auth.safieAuthenticationFlag',
    ]
  })]
})
